export default [{
	name: 'Schweizer\nTourismus-\nVerband\nSTV',
	children: [{
        name: 'Projekt-Partner',
        children: [
            { name: 'Berner Fachhochschule' },
            { name: 'ibex fairstay' },
            { name: 'Myclimate' },
            { name: 'Zürcher Hochschule \nfür angewandte Wissenschaften ZHAW' },
        ]
    }, {
        name: 'Bundesverwaltung',
        children: [
            { name: 'Bundesamt für \nRaumentwicklung ARE' },
            { name: 'Bundesamt für \nSport BFS' },
            { name: 'Bundesamt für \nStatistik BFS' },
            { name: 'Bundesamt für \nUmwelt BAFU' },
            { name: 'Schweiz Tourismus' },
            { name: 'Schweizerische Gesellschaft \nfür Hotelkredit SGH' },
            { name: 'Staatssekretariat für \nBildung, Forschung \nund Innovation SBFI' },
            { name: 'Staatssekretariat für \nWirtschaft SECO' },
        ]
    }, {
        name: 'Politik',
        children: [
            { name: 'Begleitgruppe Tourismusstrategie Bund' },
            { name: 'Litra' },
            { name: 'Parlamentarische \nGruppe für Arbeit' },
            { name: 'Parlamentarische \nGruppe Luftfahrt' },
            { name: 'Parlamentarische \nGruppe Tourismus' },
            { name: 'Regierungskonferenz \nder Gebirgskantone' },
            { name: 'Volkswirtschafts-\ndirektorenkonferenz VDK' },
        ]
    }, {
        name: 'Touristische Bildung',
        children: [
            { name: 'Bildungszentrum \nInterlaken bzi' },
            { name: 'Centre valaisan de \nperfectionnement' },
            { name: 'Ecole Athena' },
            { name: 'Feusi Bildungszentrum' },
            { name: 'Hochschule Luzern \nHSLU' },
            { name: 'Hochschule Wallis \nHES-SO' },
            { name: 'Höhere Fachschule für \nTourismus Luzern HFT' },
            { name: 'Internationale Schule für \nTourismus IST' },
            { name: 'Teilkonferenz Höhere Fachschulen \nfür Tourismus' },
        ]
    }, {
        name: 'Weitere Organisationen',
        children: [
            { name: 'Eidg. Konsultativgruppe \nProduktelabel Pärke' },
            { name: 'Projekt Oberleitung \nBeherbergungsstatistik' },
        ]
    }, {
        name: 'Branchenverbände und Organisationen',
        children: [
            { name: 'Förderverein Barrierefreie \nSchweiz FVBS',
                children: [
                    { name: 'Pro Infirmis'},
                    { name: 'Stiftung Denk an mich' },
                    { name: 'Eidgenössisches Büro \nfür Gleichstellung\n von Menschen mit Behinderungen EGBG' },
                    { name: 'Schweizer Paraplegiker \nVereinigung SPV' },
                ]
            },
            { name: 'Schneesport-Initiative',
                children: [
                    { name: 'Dachverband Lehrerinnen und \nLehrer Schweiz LCH'},
                ]
            },
            { name: 'Schweizerische Arbeitsgemeinschaft\nfür Berggebiete SAB' },
            { name: 'Förderverein \nBarrierefreie Schweiz FVBS' },
            { name: 'strasseschweiz' },
            { name: 'Verband Schweizerische \nLandesplanung SL' },
            { name: 'senesuisse' },
            { name: 'Swiss Association \nfor Quality SAQ' },
        ]
    }, {
        name: 'Touristische Verbände und Organisationen',
        children: [
            { name: 'Agrotourismus Schweiz' },
            { name: 'Bed and Breakfast \nSwitzerland' },
            { name: 'Car Tourisme Suisse, \nCar-Groupe ASTAG' },
            { name: 'GastroSuisse' },
            { name: 'Groups' },
            { name: 'Hotel & Gastro Union' },
            { name: 'hotelleriesuisse' },
            { name: 'IG Schnee' },
            { name: 'Interhome' },
            { name: 'Konferenz der regionalen \nTourismusdirektoren der Schweiz (RDK)',
                children: [
                    { name: '13 Tourismusregionen',
                        children: [
                            { name: 'Tourismusdestinationen'},
                        ]
                    },
                ]
            },
            { name: 'Netzwerk Schweizer Pärke' },
            { name: 'Parahotellerie Schweiz' },
            { name: 'Reka' },
            { name: 'Safety in adventures' },
            { name: 'Schweizer Jugendherbergen' },
            { name: 'SchweizMobil' },
            { name: 'Seilbahnen Schweiz SBS' },
            { name: 'Swiss Snowsports' },
            { name: 'Verband \nöffentlicher Verkehr VöV' },
            { name: 'Verband Schweizer \nTourismus-Manager VSTM' },
        ]
    }, {
        name: 'Tourismuspreise / Jury / Patronate',
        children: [
            { name: 'Festival der Natur' },
            { name: 'Innovationsgenerator' },
            { name: 'Innovationspreis \nBerner Oberland' },
            { name: 'Milestone' },
            { name: 'Prix Rando' },
            { name: 'Swiss Holiday Home Award' },
            { name: 'Tourismus Forum Schweiz' },
            { name: 'Tourismuscamp' },
        ]
    }, {
        name: 'Wissenschaft',
        children: [
            { name: 'Forschungsstelle für \nTourismus CRED-T Universität Bern' },
            { name: 'Institut für\nSystemisches Management und\nPublic Governance IPM-HSG' },
            { name: 'Institut für\nTourismus-Wirtschaft Chur ITW' },
            { name: 'Walliser Tourismusobservatorium' },
        ]
    }]
}];